// extracted by mini-css-extract-plugin
export default {"report-help__container":"styles_report-help__container__+JMjP"};